import type { Amount, Fee, FeeSection } from '@/src/types/costAndFees.type';

export function formatAmount(amount: Amount | undefined, locale = 'en-US'): string {
  if (!amount) return '$0';
  if ('displayText' in amount) return amount.displayText;
  if (!('min' in amount) || typeof amount.min !== 'number') return 'Contact';
  if (amount.max === null) return `$${amount.min.toLocaleString(locale)}+`;
  const maximum = amount.max ?? amount.min;
  if (amount.min === maximum) return `$${amount.min.toLocaleString(locale)}`;
  return `$${amount.min.toLocaleString(locale)} - $${maximum.toLocaleString(locale)}`;
}

export function getAmountMin(amount: Amount | undefined): number {
  if (!amount || 'displayText' in amount) return 0;
  return amount.min;
}

export function isBaseRentFee(fee: Fee): boolean {
  const type = fee.type.toLowerCase();
  return type === 'base_rent' || type === 'rent' || type === 'monthly_rent' || type === 'baserent';
}

export function extractFeeGroups(section: FeeSection) {
  const required: Array<Fee> = [];
  const optional: Array<Fee> = [];
  for (const group of section.feeGroup) {
    const isOptional = group.type.toUpperCase() === 'OPTIONAL';
    for (const fee of group.fees) {
      if (isOptional || fee.counter.min === 0) {
        optional.push(fee);
      } else {
        required.push(fee);
      }
    }
  }
  return { required, optional };
}

export function hasFeesInSection(section: FeeSection | undefined | null): boolean {
  if (!section?.feeGroup) return false;
  return section.feeGroup.some((group) => group.fees.length > 0);
}
